import { createReducer } from "./../../../redux/reducers/functions";

import _ from "lodash";
import moment from "moment-timezone";

import {
  STATS_ADD_FILTER,
  STATS_GRAPH_LOADING,
  STATS_RESET,
  STATS_SELECT_KPI,
  STATS_SELECT_MAIN_FILTER,
  STATS_SELECT_VIEW,
  STATS_SET_DASHBOARD_DATA,
  STATS_SET_DATA,
  STATS_SET_KPIS,
  STATS_SET_LEFT_MENU_ITEM,
  STATS_SET_PERIOD,
  STATS_SET_PERIODS_ITEM_SELECTED,
  STATS_SET_SUMMARY_DATA,
  STATS_SET_SUMMARY_DIMENSIONS,
  STATS_SET_SUMMARY_KPI,
  STATS_SET_TABLE_DATA,
  STATS_SUBFILTER_DATA,
  STATS_SUBFILTER_LOADING,
  STATS_SUBFILTER_SELECTED,
  STATS_SUBFILTER_SET_VALUES,
  STATS_SWITCH_SUMMARY_DISPLAY_TYPE,
  STATS_TABLE_LOADING,
  STATS_SET_STATS_FILTERS,
  STATS_SET_ACTIONS,
  STATS_SET_PERIODS,
  STATS_SET_SUMMARY_GAIN_CHECKED,
  STATS_SET_PERMALINK_DATA,
  STATS_TOGGLE_IS_DATA_DISPLAYED
} from "../actions/stats";
import { kpis } from "../../../configs/kpis";

const ZONES_DEFAULT = {
  //dimension filter
  z1: [1, 29, 3, 6, 4, 33, 9, 8, 5],
  z3: [29, 3, 6, 4, 33, 118, 119, 105, 8, 9, 5],
  z4: [102, 12, 31, 11, 41, 110, 38, 39, 101, 24, 100],
  z5: [
    30,
    15,
    null,
    10,
    28,
    16,
    17,
    null,
    18,
    19,
    116,
    117,
    122,
    121,
    120,
    103,
    104,
    null,
    22,
    23,
    null,
    32,
    34,
    35,
    36,
    37,
    40,
    26,
    27,
    106,
    109,
    107,
    108,
    123,
    null
  ],
  z6: [113, 111, 114, 112, 115]
};
const initialState = {
  filters: {
    product_range_properties: {
      values: ["O"],
      dataSelected: [
        {
          id: "O",
          value: "O"
        }
      ]
    }
  },
  dimensions: {},
  data: {},
  dashboardData: {},
  homeData: {},
  tableData: {},
  summaryData: {},
  kpis: [],
  actions: [],
  leftMenuItemSelected: 0,
  kpiSelected: null,
  mainFilters: [],
  mainFilterSelected: null,
  subfilterSelected: "",
  subfilterLoading: false,
  graphLoading: false,
  tableLoading: false,
  period: [moment().startOf("year"), moment()],
  periodToCompare: null,
  periods: null,
  periodsItemSelected: undefined,
  zones: ZONES_DEFAULT,
  //view: "home",
  view: "dashboard",
  summaryDimensions: ["global"],
  summaryKpi: null,
  //display type, value or ratio
  summaryDisplayType: "value",
  summaryGainChecked: false,
  isDataDisplayed: true,
};

const filters = {
  [STATS_SET_LEFT_MENU_ITEM]: (state, action) => {
    return Object.assign({}, state, {
      leftMenuItemSelected: action.leftMenuItem
    });
  },
  [STATS_SELECT_KPI]: (state, action) => {
    //reset data (cache) from filters
    const filters = { ...state.filters };
    for (const [key, data = {}] of Object.entries(filters)) {
      filters[key] = { ...data, data: null };
    }

    //MEA
    if (
      state.kpiSelected !== action.kpi &&
      (action.kpi === kpis.MEA || action.kpi === kpis.PLV || action.kpi === kpis.NB_BRI)
    ) {
      delete filters.product_range_properties;
    }

    if (
      (state.kpiSelected === kpis.MEA || state.kpiSelected === kpis.PLV || state.kpiSelected === kpis.NB_BRI) &&
      action.kpi !== kpis.MEA &&
      action.kpi !== kpis.PLV &&
      action.kpi !== kpis.NB_BRI
    ) {
      filters.product_range_properties = {
        values: ["O"],
        dataSelected: [
          {
            id: "O",
            value: "O"
          }
        ]
      };
    }

    return Object.assign({}, state, { kpiSelected: action.kpi, summaryKpi: action.kpi, filters: _.cloneDeep(filters) });
  },
  [STATS_SELECT_MAIN_FILTER]: (state, action) => {
    return Object.assign({}, state, { mainFilterSelected: action.filter });
  },
  [STATS_SUBFILTER_SELECTED]: (state, action) => {
    return Object.assign({}, state, { subfilterSelected: action.filter });
  },
  [STATS_SUBFILTER_LOADING]: (state, action) => {
    return Object.assign({}, state, { subfilterLoading: action.loading });
  },
  [STATS_GRAPH_LOADING]: (state, action) => {
    return Object.assign({}, state, { graphLoading: action.graphLoading });
  },
  [STATS_TABLE_LOADING]: (state, action) => {
    return Object.assign({}, state, { tableLoading: action.loading });
  },
  [STATS_SET_KPIS]: (state, action) => {
    action.kpis = action.kpis || [];
    const kpis = _.orderBy(action.kpis, ["dashboard_priority", "priority"], ["ASC", "ASC"]);
    return Object.assign({}, state, { kpis: kpis });
  },
  [STATS_SET_ACTIONS]: (state, action) => {
    action.actions = action.actions || [];
    const actions = _.orderBy(action.actions, ["dashboard_priority", "priority"], ["ASC", "ASC"]);
    return Object.assign({}, state, { actions: actions });
  },
  [STATS_SET_PERIODS]: (state, action) => {
    const periods = action.periods || [];

    return Object.assign({}, state, {
      periods: periods.map(period => ({
        ...period,
        id: period._id,
        value: period.label,
        dates: [period.start_date, period.end_date]
      }))
    });
  },
  [STATS_SET_STATS_FILTERS]: (state, action) => {
    const newZones = {};
    if (!Array.isArray(action.statsFilters)) return state;
    Object.entries(ZONES_DEFAULT).forEach(
      ([key, values]) => (newZones[key] = values.filter(id => action.statsFilters.indexOf(id) > -1))
    );
    return { ...state, zones: newZones };
  },
  [STATS_SUBFILTER_DATA]: (state, action) => {
    const data = action.data || [];
    const subfilterSelected = action.subfilterId;

    const filtersItem = state.filters /*[filterKey]*/ || {};
    const filtersSubItem = filtersItem[subfilterSelected] || {};

    return {
      ...state,
      filters: {
        ...state.filters,
        ...{
          ...filtersItem,
          [subfilterSelected]: {
            ...filtersSubItem,
            data: data
          }
        }
      }
    };
  },
  [STATS_SUBFILTER_SET_VALUES]: (state, action) => {
    const mainFilterSelected = state.mainFilterSelected;

    const subfilterId = action.subfilterId || "";
    const subfilterValues = action.values || [];

    const filtersItem = state.filters || {};
    const filtersSubItem = filtersItem[subfilterId] || {};

    const data = filtersSubItem.data || [];
    const dataSelected = [];

    for (let i = 0; i < subfilterValues.length; i++) {
      const subfilterValue = subfilterValues[i];
      const item = _.find(data, { id: subfilterValue });
      if (item) {
        dataSelected.push(item);
      }
    }

    const filters = {
      ...state.filters,
      ...{
        ...filtersItem,
        [subfilterId]: {
          ...filtersSubItem,
          values: subfilterValues,
          dataSelected: dataSelected
        }
      }
    };

    //remove previous data from filters(dependencies)
    for (const [subfilterKey, subfilterData = {}] of Object.entries(filters)) {
      if (subfilterKey !== subfilterId) {
        filters[subfilterKey] = { ...subfilterData, data: null };
      }
    }

    return {
      ...state,
      data: {},
      tableData: {},
      filters: { ...filters }
    };
  },
  [STATS_SET_PERIOD]: (state, action) => {
    const filters = state.filters;
    //remove previous data from filters(dependencies)
    for (const [subfilterKey, subfilterData = {}] of Object.entries(filters)) {
      filters[subfilterKey] = { ...subfilterData, data: null };
    }
    if (action.periodDesignation === "periodToCompare") {
      return Object.assign({}, state, {
        periodToCompare: action.values,
        data: {},
        dashboardData: {},
        filters: { ...filters }
      });
    }
    return Object.assign({}, state, {
      period: action.values,
      data: {},
      dashboardData: {},
      filters: { ...filters }
    });
  },
  [STATS_SET_PERIODS_ITEM_SELECTED]: (state, action) => {
    return Object.assign({}, state, { periodsItemSelected: action.item });
  },
  [STATS_SELECT_VIEW]: (state, action) => {
    return Object.assign({}, state, { view: action.view });
  },
  [STATS_SET_SUMMARY_GAIN_CHECKED]: (state, action) => {
    const filters = { ...state.filters };
    if (action.checked) {
      filters.p_visit_target = { dataSelected: [], values: ["first"] };
      filters.p_visit_statement = { dataSelected: [], values: ["start"] };
    } else {
      filters.p_visit_target = { dataSelected: [], values: ["last"] };
      filters.p_visit_statement = { dataSelected: [], values: ["end"] };
    }
    return Object.assign({}, state, { summaryGainChecked: action.checked, filters });
  }
};

const data = {
  /**
   * add retreived data to the store
   * @param state
   * @param action
   * @return {{data: {}}}
   */
  [STATS_SET_DATA]: (state, action) => {
    const data = action.data || [];
    const filterKey = state.kpiSelected + state.mainFilterSelected;
    const dataItem = data;

    return {
      ...state,
      data: {
        ...state.data,
        [filterKey]: dataItem
      }
    };
  },
  [STATS_SET_TABLE_DATA]: (state, action) => {
    const data = action.data || [];
    const filterKey = state.kpiSelected + state.mainFilterSelected;
    const dataItem = data;

    return {
      ...state,
      tableData: {
        ...state.tableData,
        [filterKey]: dataItem
      }
    };
  },
  [STATS_SET_SUMMARY_DATA]: (state, action) => {
    const data = action.data || [];
    const filterKey = state.kpiSelected + state.mainFilterSelected;
    const dataItem = data;

    return {
      ...state,
      summaryData: {
        ...state.summaryData,
        [filterKey]: dataItem
      }
    };
  },
  [STATS_SET_DASHBOARD_DATA]: (state, action) => {
    const data = action.data || [];
    const kpiSelected = state.kpiSelected;
    const dataItem = data;
    return {
      ...state,
      dashboardData: {
        ...state.dashboardData,
        [kpiSelected]: dataItem
      }
    };
  },
  [STATS_RESET]: state => {
    return Object.assign({}, state, {
      filters: {
        product_range_properties: {
          values: ["O"],
          dataSelected: [
            {
              id: "O",
              value: "O"
            }
          ]
        }
      },
      dimensions: {},
      data: {},
      dashboardData: {},
      homeData: {},
      kpis: [],
      leftMenuItemSelected: 0,
      kpiSelected: null,
      mainFilters: [],
      mainFilterSelected: null,
      subfilterSelected: "",
      subfilterLoading: false,
      graphLoading: false
    });
  }
};

const addFilter = {
  [STATS_ADD_FILTER]: (state, action) => {
    let filterIndex = _.find(state.filters, {
      kpiId: state.leftMenuItemSelected,
      globalFilterId: state.leftMenuGlobalFilterSelected
    });
    const currentFilter = {
      kpiId: state.leftMenuItemSelected,
      globalFilterId: state.leftMenuGlobalFilterSelected,
      ...action.filter
    };
    const currentFilters = state.filters;

    if (filterIndex === -1) {
      currentFilters.push(currentFilter);
    } else {
      currentFilters[filterIndex] = currentFilter;
    }

    return Object.assign({}, state, { filters: currentFilters });
  }
};

const summary = {
  [STATS_SET_SUMMARY_DIMENSIONS]: (state, action) => {
    return {
      ...state,
      summaryDimensions: [...action.data]
    };
  },
  [STATS_SET_SUMMARY_KPI]: (state, action) => {
    return {
      ...state,
      summaryKpi: action.kpi
    };
  },
  [STATS_SWITCH_SUMMARY_DISPLAY_TYPE]: (state, action) => {
    return {
      ...state,
      summaryDisplayType: state.summaryDisplayType === "ratio" ? "value" : "ratio"
    };
  },
  [STATS_SET_PERMALINK_DATA]: (state, action = {}) => {
    return {
      ...state,
      ...action.data
    };
  },
  [STATS_TOGGLE_IS_DATA_DISPLAYED]: (state, action) => {
    return {
      ...state,
      isDataDisplayed: !state.isDataDisplayed
    };
  }
};
const statsReducer = createReducer(initialState, {
  ...filters,
  ...data,
  ...addFilter,
  ...summary
});

export default statsReducer;



// WEBPACK FOOTER //
// src/modules/stats/reducers/statsReducer.js